module.exports = __webpack_public_path__ + "img/bitong.e9811cc9.jpg";